import React from "react";
import Footer from "../../components/ui/Footer";
import Header from "../../components/ui/Header";

const CookiePolicyPage = () => {
  return (
    <>
      <Header />
      <div className="container mx-auto p-4 text-black text-lg" style={{ backgroundColor: '#E9A969' }}>
        <h1 className="text-3xl font-bold mb-4">Cookie Policy</h1>
        <p><strong>Effective Date:</strong> 15/07/2025</p>

  <p>This Cookie Policy explains how <strong>Cosmelytix</strong> ("we", "us", or "our") uses cookies and similar technologies when you visit our website or use our services.</p>

  <h2>1. What Are Cookies?</h2>
  <p>Cookies are small text files stored on your device by your browser when you visit websites. They help websites function, remember your preferences, and understand user behavior.</p>

  <h2>2. How We Use Cookies</h2>
  <p>We use cookies for the following purposes:</p>
  <ul>
    <li><strong>Essential Cookies</strong>: Required for basic functionality, such as maintaining login sessions and protecting user data.</li>
    <li><strong>Performance & Analytics Cookies</strong>: Help us understand how users interact with the platform, improve content, and optimize performance (e.g., Google Analytics).</li>
    <li><strong>Functionality Cookies</strong>: Remember your settings and preferences to personalize your experience.</li>
  </ul>

  <h2>3. Third-Party Cookies</h2>
  <p>Some cookies may be set by third-party services integrated into Cosmelytix, such as:</p>
  <ul>
    <li>Google (for analytics and login)</li>
    <li>Facebook (for login and user authentication)</li>
  </ul>
  <p>We do not control the data collected by these third parties and recommend reviewing their respective privacy and cookie policies.</p>

  <h2>4. Managing Your Cookie Preferences</h2>
  <p>You can control or disable cookies in your browser settings. However, disabling some cookies may affect the functionality of the site.</p>
  <ul>
    <li>Check your browser's help section to learn how to delete or block cookies.</li>
    <li>You may also use browser extensions or opt-out tools offered by services like Google.</li>
  </ul>

  <h2>5. Changes to This Cookie Policy</h2>
  <p>We may update this policy from time to time. Any changes will be posted on this page with a new effective date. Your continued use of Cosmelytix signifies your acceptance of these changes.</p>

  <h2>6. Contact Us</h2>
  <p>If you have questions about our Cookie Policy, you can reach us at:<br />
  <a href="mailto:[info@cosmelytix.com]" style={{'color': '#5F40A1'}}>info@cosmelytix.com</a><br />
            <a href="https://cosmelytix.com/" className="text-[#5F40A1]">cosmelytix.com</a>
  </p>

      </div>
      <Footer />
    </>
  );
};

export default CookiePolicyPage;